import type { IRatePlanDetails } from "@payfac/types";

export const initialData = {
  name: "",
  tax: {
    pix: {
      value: null,
      rateType: "PERCENTAGE",
      valueLimit: null,
      delayForRedeem: null,
    },
    debit: {
      value: null,
      rateType: "PERCENTAGE",
      delayForRedeem: null,
    },
    bankSlip: {
      value: null,
      rateType: "PERCENTAGE",
      valueLimit: null,
      delayForRedeem: null,
    },
    receiptType: "TIMELINE",
    credit: [
      {
        online: {
          default: { sellerRates: Array(24).fill(null) },
          delayForRedeem: 30,
        },
      },
      {
        pos: {
          default: { sellerRates: Array(24).fill(null) },
          delayForRedeem: 30,
        },
      },
      {
        tap: {
          default: { sellerRates: Array(24).fill(null) },
          delayForRedeem: 30,
        },
      },
    ],
  },
} as unknown as IRatePlanDetails;
